import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/labels', params),
    getById: (id) => Api.get(`/cent/label/${id}`),
    save: (params) => Api.post('/cent/label', params),
    update: (id, params) => Api.put(`/cent/label/${id}`, params),
    delete: (id) => Api.delete(`/cent/label/${id}`)
};
